import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { ProfileContext } from "../../context/ProfileProvider";
import { FUTURES_SUBMENU_ITEMS } from "../headerFuturesSubmenu";
import { FALLBACK_CATALOG, footerBuySellItems } from "../../ui/Pages/BuySellPage/convertCatalog";
import "./footer-app-download.css";

const FOOTER_BUY_CRYPTO_PRODUCTS_ITEMS = footerBuySellItems(FALLBACK_CATALOG);

const closeNavAndScroll = (setOpenFooterNavKey, handleupper) => {
    setOpenFooterNavKey(null);
    handleupper();
};

const FooterNavDropdown = ({ navKey, openKey, setOpenKey, label, idSlug, items, handleupper }) => {
    const isOpen = openKey === navKey;
    return (
        <li className={`footer_menu_has_sub${isOpen ? " open" : ""}`}>
            <button
                type="button"
                className="footer_trade_crypto_toggle"
                aria-expanded={isOpen}
                aria-controls={`footer-nav-${idSlug}-sub`}
                id={`footer-nav-${idSlug}-trigger`}
                onClick={() => setOpenKey((prev) => (prev === navKey ? null : navKey))}
            >
                <span>{label}</span>
                <i className="ri-arrow-down-s-line footer_trade_crypto_chevron" aria-hidden />
            </button>
            <ul id={`footer-nav-${idSlug}-sub`} className="footer_menu_sub" hidden={!isOpen}>
                {items.map((item) => (
                    <li key={item.id}>
                        <Link to={item.to} onClick={() => closeNavAndScroll(setOpenKey, handleupper)}>
                            {item.title}
                        </Link>
                    </li>
                ))}
            </ul>
        </li>
    );
};

const APP_DOWNLOAD_OPTIONS = [
    { id: "android", label: "Android Download", scan: "Scan to download the AGCX Android app", icon: "ri-android-fill" },
    { id: "ios", label: "iOS Download", scan: "Scan to download the AGCX iOS app", icon: "ri-apple-fill" },
];

const FooterAppDownload = ({ onNavigate }) => {
    return (
        <section className="footer_app_download" aria-label="Download the AGCX app">
            <h2>Trade.Execute.Evolve</h2>
            <p>
                Start with a simple download. </p>
            <div className="footer_app_download__actions">
                {APP_DOWNLOAD_OPTIONS.map((option) => (
                    <div key={option.id} className="footer_app_dl__card">
                        <button
                            type="button"
                            className="footer_app_dl__icon"
                            aria-label={option.label}
                        >
                            <i className={option.icon} aria-hidden="true" />
                        </button>
                        <div className="footer_app_dl__popover" role="tooltip">
                            <img src="/images/scan.png" alt="" />
                            <p>{option.scan}</p>
                            <Link to="/download_app" onClick={onNavigate}>
                                {option.label}
                            </Link>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

const Footer = () => {
    const { setActiveTab } = useContext(ProfileContext);
    const [activeFooterSection, setActiveFooterSection] = useState(null);
    const [openFooterNavKey, setOpenFooterNavKey] = useState(null);

    const handleupper = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const toggleFooterSection = (key) => (e) => {
        e.preventDefault();
        setActiveFooterSection((prev) => (prev === key ? null : key));
    };

    return (
        <>
            <footer className="p-0">
                <div className="container" />

                <div className="row main_footer_menu_s m-0">
                    <div className="container">
                        <div className="mobile_grid_list">
                            <div className="footer_section order-last">
                                <div className="footer_left">
                                    <Link to="/" className="footer_brand_logo" onClick={handleupper} aria-label="AGCX home">
                                        <img src="/images/applogo.png" alt="AGCX" />
                                    </Link>
                                    <FooterAppDownload onNavigate={handleupper} />

                                    <div className="social_footer">
                                        <h3>Community</h3>
                                        <ul className="social_footer_icons" aria-label="Social media links">

                                            <li>
                                                <a
                                                    href="https://x.com/AGCX_official"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    aria-label="X"
                                                >
                                                    <img src="/images/footer_social3.png" alt="X" />
                                                </a>
                                            </li>

                                            <li>
                                                <a
                                                    href="https://www.instagram.com/agcx_official/"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    aria-label="Instagram"
                                                >
                                                    <img src="/images/footer_social6.png" alt="instagram" />
                                                </a>
                                            </li>


                                            <li>
                                                <a href="https://www.linkedin.com/company/110573936/admin/dashboard/" target="_blank" rel="noopener noreferrer" aria-label="Warp">
                                                    <img src="/images/footer_social8.png" alt="linkdin" />
                                                </a>
                                            </li>

                                            <li>
                                                <a href="https://www.facebook.com/AGCXUAE/" target="_blank" rel="noopener noreferrer" aria-label="Warp">
                                                    <img src="/images/footer_social2.png" alt="facebook" />
                                                </a>
                                            </li>

                                            <li>
                                                <a href="https://t.me/agcx_official" target="_blank" rel="noopener noreferrer" aria-label="Warp">
                                                    <img src="/images/footer_social4.png" alt="telegram" />
                                                </a>
                                            </li>

                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className={`footer_section ${activeFooterSection === "about" ? "active" : ""}`}>
                                <div
                                    className="topheading_footer"
                                    onClick={toggleFooterSection("about")}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            toggleFooterSection("about")(e);
                                        }
                                    }}
                                    aria-expanded={activeFooterSection === "about"}
                                >
                                    <h3>About Us</h3>
                                    <div className="icon_i">
                                        <i className="ri-arrow-down-s-line" aria-hidden />
                                        <i className="ri-arrow-up-s-line" aria-hidden />
                                    </div>
                                </div>
                                <ul className="menu">
                                    <li>
                                        <Link to="/about_us/company" onClick={handleupper}>
                                            Company
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/about_us/team" onClick={handleupper}>
                                            Team
                                        </Link>
                                    </li>
                                    {/* <li>
                                        <Link to="/careers" onClick={handleupper}>
                                            Careers
                                        </Link>
                                    </li> */}
                                    <li>
                                        <Link to="/user_agreement" onClick={handleupper}>
                                            User Agreement
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/RiskDisclosure" onClick={handleupper}>
                                            Risk Disclosure
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/privacy_policy" onClick={handleupper}>
                                            Privacy Policy
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/delete-account" onClick={handleupper}>
                                            Delete Account
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/aml-kyc-policy" onClick={handleupper}>
                                            AML Policy
                                        </Link>
                                    </li>
                                    {/* <li>
                                        <Link to="/kyb" onClick={handleupper}>
                                            KYB
                                        </Link>
                                    </li> */}
                                    {/* <li>
                                        <Link to="/license" onClick={handleupper}>
                                            License
                                        </Link>
                                    </li> */}
                                    <li>
                                        <Link to="/security_system" onClick={handleupper}>
                                            Security
                                        </Link>
                                    </li>
                                    {/* <li>
                                        <Link to="/bug-bounty" onClick={handleupper}>
                                            Bug Bounty
                                        </Link>
                                    </li> */}
                                    {/* <li>
                                        <Link to="/token" onClick={handleupper}>
                                            AGCX Token
                                        </Link>
                                    </li> */}
                                    {/* <li>
                                        <Link to="/low_enforcement" onClick={handleupper}>
                                            Low Enforcement
                                        </Link>
                                    </li> */}
                                    <li>
                                        <Link to="/terms_conditions" onClick={handleupper}>
                                            Terms & Conditions
                                        </Link>
                                    </li>
                                </ul>
                            </div>

                            <div className={`footer_section ${activeFooterSection === "products" ? "active" : ""}`}>
                                <div
                                    className="topheading_footer"
                                    onClick={toggleFooterSection("products")}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            toggleFooterSection("products")(e);
                                        }
                                    }}
                                    aria-expanded={activeFooterSection === "products"}
                                >
                                    <h3>Products</h3>
                                    <div className="icon_i">
                                        <i className="ri-arrow-down-s-line" aria-hidden />
                                        <i className="ri-arrow-up-s-line" aria-hidden />
                                    </div>
                                </div>
                                <ul className="menu">
                                    <li>
                                        <Link to="/spot_trading" onClick={handleupper}>
                                            Spot Trading
                                        </Link>
                                    </li>
                                    <FooterNavDropdown
                                        navKey="futures"
                                        openKey={openFooterNavKey}
                                        setOpenKey={setOpenFooterNavKey}
                                        label="Futures"
                                        idSlug="futures"
                                        items={FUTURES_SUBMENU_ITEMS}
                                        handleupper={handleupper}
                                    />
                                    <li>
                                        <Link to="/margin_trading" onClick={handleupper}>
                                            Margin Trading
                                        </Link>
                                    </li>
                                    <FooterNavDropdown
                                        navKey="buy_crypto"
                                        openKey={openFooterNavKey}
                                        setOpenKey={setOpenFooterNavKey}
                                        label="Buy Crypto"
                                        idSlug="buy-crypto"
                                        items={FOOTER_BUY_CRYPTO_PRODUCTS_ITEMS}
                                        handleupper={handleupper}
                                    />
                                    {/* <li>
                                        <Link to="/copy-trading" onClick={handleupper}>
                                            Copy Trading
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/convert_trading" onClick={handleupper}>
                                            Convert Trading
                                        </Link>
                                    </li> */}
                                    <li>
                                        <Link to="/launchpad" onClick={handleupper}>
                                            Launchpad
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/staking" onClick={handleupper}>
                                            Staking
                                        </Link>
                                    </li>
                                    {/* <li>
                                        <Link to="/otc" onClick={handleupper}>
                                            OTC Desk
                                        </Link>
                                    </li> */}
                                    {/* <li>
                                        <Link to="/square" onClick={handleupper}>
                                            Square
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/referral_rewards" onClick={handleupper}>
                                            Referral Rewards
                                        </Link>
                                    </li> */}
                                    {/* <li>
                                        <Link to="/air_drop" onClick={handleupper}>
                                            AGCX Air Drop
                                        </Link>
                                    </li>*/}
                                    {/* <li>
                                        <Link to="/wait-list" onClick={handleupper}>
                                            Waitlist
                                        </Link>
                                    </li> */}
                                </ul>
                            </div>

                            <div className={`footer_section ${activeFooterSection === "support" ? "active" : ""}`}>
                                <div
                                    className="topheading_footer"
                                    onClick={toggleFooterSection("support")}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            toggleFooterSection("support")(e);
                                        }
                                    }}
                                    aria-expanded={activeFooterSection === "support"}
                                >
                                    <h3>Services</h3>
                                    <div className="icon_i">
                                        <i className="ri-arrow-down-s-line" aria-hidden />
                                        <i className="ri-arrow-up-s-line" aria-hidden />
                                    </div>
                                </div>
                                <ul className="menu">
                                    <li>
                                        <Link to="/vip_benefits" onClick={handleupper}>
                                            VIP Benefits
                                        </Link>
                                    </li>
                                    {/* <li>
                                        <Link to="/user_feedback" onClick={handleupper}>
                                            User Feedback
                                        </Link>
                                    </li> */}
                                    <li>
                                        <Link to="/announcement" onClick={handleupper}>
                                            Announcement
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/fees" onClick={handleupper}>
                                            Fees
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/help_center" onClick={handleupper}>
                                            Help Center
                                        </Link>
                                    </li>
                                    {/* <li>
                                        <Link to="/submit_request" onClick={handleupper}>
                                            Submit a Request
                                        </Link>
                                    </li> */}
                                    <li>
                                        <Link to="/Listing" onClick={handleupper}>
                                            Listing
                                        </Link>
                                    </li>
                                    {/* <li>
                                        <Link to="/developers" onClick={handleupper}>
                                            Developer
                                        </Link>
                                    </li> */}
                                    {/* <li>
                                        <Link to="/affiliate_program" onClick={handleupper}>
                                            Affiliate Program
                                        </Link>
                                    </li> */}
                                    <li>
                                        <Link to="/crypto_market" onClick={handleupper}>
                                            Crypto Market
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/deposit_crypto" onClick={handleupper}>
                                            Deposit Crypto
                                        </Link>
                                    </li>
                                    {/* <li>
                                        <Link to="/otc_service" onClick={handleupper}>
                                            OTC Service
                                        </Link>
                                    </li> */}
                                </ul>
                            </div>

                            <div className={`footer_section ${activeFooterSection === "learn" ? "active" : ""}`}>
                                <div
                                    className="topheading_footer"
                                    onClick={toggleFooterSection("learn")}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            toggleFooterSection("learn")(e);
                                        }
                                    }}
                                    aria-expanded={activeFooterSection === "learn"}
                                >
                                    <h3>Learn</h3>
                                    <div className="icon_i">
                                        <i className="ri-arrow-down-s-line" aria-hidden />
                                        <i className="ri-arrow-up-s-line" aria-hidden />
                                    </div>
                                </div>
                                <ul className="menu">
                                    <li>
                                        <Link to="/blog_news" onClick={handleupper}>
                                            Blog & News
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/why_agcx" onClick={handleupper}>
                                            Why AGCX?
                                        </Link>
                                    </li>

                                    <div
                                        className="topheading_footer mt-4 download_app_footer"
                                        onClick={toggleFooterSection("download_app")}
                                        role="button"
                                        tabIndex={0}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter" || e.key === " ") {
                                                e.preventDefault();
                                                toggleFooterSection("download_app")(e);
                                            }
                                        }}
                                        aria-expanded={activeFooterSection === "download_app"}
                                    >
                                        <h3>Download App</h3>
                                        <div className="icon_i">
                                            <i className="ri-arrow-down-s-line" aria-hidden />
                                            <i className="ri-arrow-up-s-line" aria-hidden />
                                        </div>
                                    </div>
                                    <li>
                                        <Link to="/download_app" onClick={handleupper}>
                                            Android App Download
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/download_app" onClick={handleupper}>
                                            iOS App Download
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-12">
                    <div className="copyright_s">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 col-12 mt-4 text-center">
                                    <p className="copyright-text">
                                        Copyright © 2026{" "}
                                        <b className="AGCX">
                                            <a href="https://arabglobal.ae/" target="_blank" rel="noopener noreferrer">
                                                AGCX
                                            </a>
                                        </b>
                                        . All rights reserved
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer >

            {/* <footer>
                <div className="ft-grid">
                    <div className="ft-brand">
                        <a href="#" className="ft-logo">
                            <img class="darkogo" src="/images/logo_light.svg" alt="logo" />
                        </a>
                        <p className="ft-desc">The next-generation digital asset exchange engineered for ultra-low latency, bulletproof security, and deep global liquidity.</p>

                        <span className="ft-copy-sub">Arab Global Virtual Assets Services LLC SPC is registered as a Virtual Asset Service Provider. Virtual asset trading involves significant risk, including the risk of total loss of capital. Please ensure you understand the risks before trading.</span>


                    </div>

                    <div className="ft-col linkftr">
                        <div className="ft-title">Links</div>
                        <div className="ft-col-links-list">
                            <Link to="/about_us/company" className="ft-link">About</Link>
                            <Link to="/otc" className="ft-link">OTC Desk</Link>
                            <Link to="/otc" className="ft-link">OTC Service</Link>
                            <Link to="/earn-new" className="ft-link">AGCX Earn</Link>
                            <Link to="/token" className="ft-link">AGCX Token</Link>
                            <Link to="/coin_list" className="ft-link">List Your Project</Link>
                            <Link to="/affiliate_program" className="ft-link">Affiliate Program</Link>
                            <Link to="/privacy_policy" className="ft-link">Privacy Policy</Link>
                            <Link to="/RiskDisclosure" className="ft-link">Risk Disclosure</Link>
                            <Link to="/TermsofUse" className="ft-link">Terms of Use</Link>
                            <Link to="/user_agreement" className="ft-link">User Agreement</Link>
                            <Link to="/kyb" className="ft-link">KYB</Link>
                        </div>
                    </div>

                    <div className="ft-brand-company">
                        <div className="ft-title">Company</div>
                        <div className="ft-link ft-brand-company-name">
                            Arab Global Virtual Assets LLC SPC<br /><br />
                            <strong>Address:</strong> Unit 1603, Commercial tower C, Building no 19, Sector - E11, Plot No C87, Electra Road, Abu Dhabi 340004
                            <br /><br />
                            <strong>Phone:</strong> <a href="tel:+97125468911" className="ft-link ft-link-email">+971  25468911</a>
                        </div>
                    </div>

                    <div className="ft-col ft-col-contact">
                        <div className="ft-title">Contact Us</div>
                        <div className="ft-col-contact-body">
                            <p>For any queries reach out to us on:</p>
                            <a href="mailto:compliance@arabglobal.ae" className="ft-link ft-link-email">compliance@arabglobal.ae</a>
                            <a href="mailto:contactus@arabglobal.ae" className="ft-link ft-link-email">contactus@arabglobal.ae</a>
                        </div>
                    </div>


                </div>
                <div className="ft-bottom">
                    <div className="ft-copy">
                        &copy; 2026 Arab Global Crypto Exchange. All rights reserved.
                        Arab Global Crypto Exchange is operated by Arab Global Virtual Assets LLC SPC.<a href="https://www.uaecma.gov.ae/en/open-data/licensed-companies?q=CP-0001628" target="_blank" rel="noopener noreferrer" className="ft-link">Regulated by CMA, UAE</a>
                    </div>
                </div>
            </footer> */}
        </>
    );
};

export default Footer;
